exports = module.exports = require("../../../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-financial {\n    padding-left: 20px;\n}\n\n.financial-holder {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    justify-items: center;\n    align-content: center;\n    align-content: center;\n    flex-wrap: wrap;\n}", ""]);

// exports
